import { Component, Element, h, Host, Listen, Prop, Watch } from '@stencil/core';
import {
  handleItemNotification,
  StickyToolbarItemNotification,
} from '../../../../global/utility/sticky-toolbar/sticky-toolbar-helpers';

interface UiCmsStickyToolbarMobileItemBody {
  src: string;
  target?: '_self' | '_blank';
  iconPath: string;
  label: string;
  notification?: StickyToolbarItemNotification;
}

@Component({
  tag: 'ui-cms-sticky-toolbar-mobile-item',
  styleUrl: 'ui-cms-sticky-toolbar-mobile-item.scss',
})
export class UiCmsStickyToolbarMobileItem {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) body: UiCmsStickyToolbarMobileItemBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Listen('notificationStart')
  onNotificationStart() {
    this.el.classList.add('notify');
  }

  @Listen('notificationStop')
  onNotificationStop() {
    this.el.classList.remove('notify');
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    if (this.body?.notification?.id) {
      handleItemNotification(this.el, this.body.notification, true);
    }
  }

  render() {
    return (
      <Host class="sticky-toolbar-mobile-item">
        <sd-link class="sticky-toolbar-mobile-item__link" href={this.body.src} target={this.body.target || '_blank'}>
          <span class="sr-only">{this.body.label}</span>
          <sd-icon class="sticky-toolbar-mobile-item__icon" color="white" name={this.body.iconPath}></sd-icon>
        </sd-link>
      </Host>
    );
  }
}
